import { HOST_APP_DEFAULT_PROD_URL, HOST_APP_PROD_HOSTS, META_APP_NAMES } from './consts'

import type { AppEnvMap, AppEnvConfig } from '@zto/zpage'
import type { KtHostAppEnv } from './typings'

export const HOST_APP_HOSTS = {
  DEV: '127.0.0.1:3110',
  TEST: 'yxg-test.toodali.com',
  PRE: 'yxg-pre.toodali.com'
}

// 通用环境变量
const CommonEnv = {
  appNs: 'tuda-cabinet-retail-web',
  appId: '91576d53-a36d-49c7-b690-5d8f28fba2b0',
  requestSource: 'pc' // 请求标识为pc，和小程序及其他平台区分
}

// 通用测试环境变量
export const TestEnv: AppEnvConfig<KtHostAppEnv> = {
  ...CommonEnv,
  hostUrl: `https://${HOST_APP_HOSTS.TEST}`,
  baseUserApiUrl: 'https://test-api.toodali.com',
  // TODO: 测试环境合并后需还原
  apiUrl: 'https://test-api.toodali.com'
  // apiUrl: 'http://10.10.132.254:8080'
}

// 开发环境变量
export const DevEnv: AppEnvConfig<KtHostAppEnv> = {
  ...TestEnv,
  hostUrl: `http://${HOST_APP_HOSTS.DEV}`
}

// 通用生产环境变量
export const ProdEnv: AppEnvConfig<KtHostAppEnv> = {
  ...CommonEnv,
  hostUrl: HOST_APP_DEFAULT_PROD_URL,
  baseUserApiUrl: 'https://api.toodali.com',
  apiUrl: 'https://api.toodali.com'
}

// 预发环境变量
export const PreEnv: AppEnvConfig<KtHostAppEnv> = {
  ...ProdEnv,
  hostUrl: `http://${HOST_APP_HOSTS.PRE}`,
  extraHeaders: { 'x-dubbo-tag': 'pre' }
}

export const envMap: AppEnvMap<KtHostAppEnv> = {
  dev: {
    // 开发/本地环境
    HOSTs: [HOST_APP_HOSTS.DEV],
    ENV: { ...DevEnv }
  },

  test: {
    // 测试环境
    HOSTs: [HOST_APP_HOSTS.TEST],
    ENV: { ...TestEnv }
  },

  pre: {
    // 预发布环境
    HOSTs: [HOST_APP_HOSTS.PRE],
    ENV: { ...PreEnv }
  },

  prod: {
    // 生产环境
    HOSTs: HOST_APP_PROD_HOSTS,
    ENV: { ...ProdEnv }
  }
}
